import { render, staticRenderFns } from "./CreateUpdateAcheteurForm.vue?vue&type=template&id=5e2d904c&scoped=true&"
import script from "./CreateUpdateAcheteurForm.vue?vue&type=script&lang=ts&"
export * from "./CreateUpdateAcheteurForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateUpdateAcheteurForm.vue?vue&type=style&index=0&id=5e2d904c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d904c",
  null
  
)

export default component.exports